export default __webpack_public_path__ + "static/media/what-we-offers-06.c33d7af5.jpg";